import { HistoriqueVaccinationStructuredBody } from "src/app/services/dmp/dmp-service.abstract";
import { DmpFormatEnum } from "../../enums/dmp-format.enum";

export interface DmpHlGetDocumentContentResponse {
    Performer: DmpDocumentPerformer;
    i_documentFormat: DmpFormatEnum;
    s_cdaContentInBase64: string;
    s_cdaHeadersInBase64: string;
    s_documentFormatCode: string;
    s_documentFormatDescription: string;
    s_fileContentInBase64: string;
    StructuredBody: HistoriqueVaccinationStructuredBody;
}

export interface DmpDocumentPerformer {
    Hp: DmpDocumentPerformerHp;
    i_role: DmpDocumentPerformerRoleEnum;
}

export interface DmpDocumentPerformerHp {
    i_hpAuthenticationMode: DmpDocumentPerformerHpAuthModeEnum;
    i_hpInternalIdType: DmpDocumentPerformerHpIdTypeEnum;
    s_hpGiven: string;
    s_hpInstitution: string;
    s_hpInternalId: string;
    s_hpName: string;
    s_hpProfession: string;
    s_hpProfessionDescription: string;
    s_hpProfessionOid: string;
    s_hpSpeciality: string;
    s_hpSpecialityDescription: string;
}

export enum DmpDocumentPerformerHpAuthModeEnum {
    'InternetProtocol' = 1,
    'InternetProtocolPassword' = 2,
    'Kerberos' = 3,
    'MobileOneFactorUnregistered' = 4,
    'MobileTwoFactorUnregistered' = 5,
    'MobileOneFactorContract' = 6,
    'MobileTwoFactorContract' = 7,
    'Password' = 8,
    'PasswordProtectedTransport' = 9,
    'PreviousSession' = 10,
    'PublicKeyX509' = 11,
    'PublicKeyPGP' = 12,
    'PublicKeySPKI' = 13,
    'PublicKeyXMLDigitalSignature' = 14,
    'Smartcard' = 15,
    'SmartcardPKI' = 16,
    'SoftwarePKI' = 17,
    'Telephony' = 18,
    'TelephonyNomadic' = 19,
    'TelephonyPersonalized' = 20,
    'TelephonyAuthenticated' = 21,
    'SecureRemotePassword' = 22,
    'SSL_TLSCertificateBasedClientAuthentication' = 23,
    'TimeSyncToken' = 24,
    'Unspecified' = 25,
}

export enum DmpDocumentPerformerHpIdTypeEnum {
    "Numéro INS patient" = 1,
    "Numéro INS-C patient" = 2,
    "Numéro RPPS" = 3,
    "Numéro ADELI" = 4,
    "Numéro SIRIUS" = 5,
    "Numéro étudiant" = 6,
    "Numéro interne d'une structure ADELI" = 7,
    "Numéro interne d'une structure FINESS" = 8,
    "Numéro interne d'une structure SIREN" = 9,
    "Numéro interne d'une structure SIRET" = 10,
    "Numéro interne RPPS" = 11,
    "Numéro interne (autre)" = 12,
}

export enum DmpDocumentPerformerRoleEnum {
    'Acteur' = 1,
    'Acteur principal' = 2,
    'Assistant' = 3,
}
